import { createContext, useContext, type ReactNode } from 'react';

import type { EnterprisePartner } from '~/gql/graphql';

export type { EnterprisePartner } from '~/gql/graphql';

const PartnerConfigContext = createContext<EnterprisePartner | null>(null);

export function PartnerConfigProvider({ children, config }: { children: ReactNode; config: EnterprisePartner | null }) {
  return <PartnerConfigContext.Provider value={config}>{children}</PartnerConfigContext.Provider>;
}

export function usePartnerConfig(): EnterprisePartner | null {
  return useContext(PartnerConfigContext);
}
